export const FAQS_COPY = {
  pageTitle: "FAQs",
  sectionTitle: "Frequently Asked Questions",
  subtitle: "Answers to the questions we get asked most.",
  retry: "Try again",
};

export const FAQS_EMPTY_STATES = {
  noFaqs: {
    title: "No FAQs Yet",
    body: "Answers to common questions will show up here.",
  },
  listError: {
    title: "Could Not Load FAQs",
    body: "Something went wrong while reading the FAQs.",
  },
};
